// Copied from platform/app/src/utils/styles.ts (the kit can't import from Platform).
export function classNames(obj: Record<string, boolean>): string {
    return Object.keys(obj)
        .filter((k) => obj[k])
        .join(' ');
}
